import { render, staticRenderFns } from "./Siderbar.vue?vue&type=template&id=bc19e6d0&"
import script from "./Siderbar.vue?vue&type=script&lang=js&"
export * from "./Siderbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports